import axios from "axios";
import qs from "qs";
import MD5 from "js-md5";

const appId = process.env.VUE_APP_appId;
const secret = process.env.VUE_APP_secret;
let sysTime: any = 0;
let difference: any = 0;

~(function getSysTime() {
	let now = new Date().getTime();
	// 如果本机时间和服务器时间差超过三分钟则获取服务器时间，否则取本机时间
	let request: any = new XMLHttpRequest();
	request.open("GET", "https://clock.ule.com/now/?_=" + new Date().getTime(), false);
	request.send();
	if (request.status === 200) {
		sysTime = request.response*1000;
		difference = sysTime - now;
	}
})();

export default function $axios(options: any) {
	let baseUrl: string = process.env.VUE_APP_BASE_API;
	const instance = axios.create({
		baseURL: baseUrl,
		method: options.method || "post",
		timeout: options.timeout || 10000, // 请求超时时间
		transformResponse: [(data) => data],
		withCredentials: true,
	});
	// request 拦截器
	instance.interceptors.request.use(
		(config: any) => {
			config.headers = {
				Accept: "application/json;_p=mall;_c=yzs;", // 设置很关键
				...config.headers,
			};
			//只有Content-Type为multipart/form-data时不需要序列化
			if(!config.noQS && config.headers['Content-Type']!='multipart/form-data'){
				config.data = qs.stringify(config.data);
			}
			if (config.formJson) {//请求数据以对象读取方式传递   例:  activityGoods[0].addStorageNum: 1
				config.data = qs.stringify(config.data,{arrayFormat: config.arrayFormat || 'indices',allowDots:true});
			}
			let url: string = config.url;
			if (url.indexOf("?") < 0) {
				url += "?";
			}
			url += "&appId=" + appId;
			let t = new Date().getTime();
			t = t + difference;
			url += "&timestamp=" + t;

			let md5Str = appId + secret + t;
			let md5Sign = MD5(md5Str);
			url += "&sign=" + md5Sign;

			config.url = url;
			return config;
		},
		(error) => {
			return Promise.reject(error); // 在调用的那边可以拿到(catch)你想返回的错误信息
		}
	);

	// response 拦截器
	instance.interceptors.response.use(
		(response) => {
			let data;
			// IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
			if (response.data == undefined) {
				data = response.request.responseText;
			} else {
				data = response.data;
			}
			return eval("(" + data + ")");
		},
		(err) => {
			if (err && err.response) {
				switch (err.response.status) {
					case 400:
						err.msg = "请求错误";
						break;

					case 401:
						err.msg = "未登录";
						break;
					case 1018:
						err.msg = "未登录";
						break;
					case 1019:
						err.msg = "登录失效";
						break;

					case 403:
						err.msg = "拒绝访问";
						break;

					case 404:
						err.msg = `请求地址出错: ${err.response.config.url}`;
						break;

					case 408:
						err.msg = "请求超时";
						break;

					case 500:
						err.msg = "服务器内部错误";
						break;

					case 501:
						err.msg = "服务未实现";
						break;

					case 502:
						err.msg = "网关错误";
						break;

					case 503:
						err.msg = "服务不可用";
						break;

					case 504:
						err.msg = "网关超时";
						break;

					case 505:
						err.msg = "HTTP版本不受支持";
						break;

					default:
				}
			}
			return Promise.reject(err); // 返回接口返回的错误信息
		}
	);

	//请求处理
	return instance(options)
		.then((res: any) => {
			// if(res.code == '1018' || res.code == '1019'){
			//     let target = location.href + "?t=" + new Date().getTime()
			//     location.href = '//m' + process.env.VUE_APP_URI_DOMAIN + '/muser/user/login?target=' + target
			//     return false
			// }
			if (res.code == "0000" || options.resolve) {
				return Promise.resolve(res.data);
			} else {
				// if (!options.isHideToast)
				//     window.vant.Toast({
				//         message: res.msg,
				//         position: 'bottom',
				//         className: 'topIndex',
				//         duration: 2000
				//     })
				return Promise.reject(res);
			}
		})
		.catch((err: any) => {
			// if (!options.isHideToast) {
			//     window.vant.Toast({
			//         message: '哎呀，小伙伴热情太高啦，挤爆了，逛逛在回来吧',
			//         position: 'bottom',
			//         className: 'topIndex'
			//     })
			// }
			return Promise.reject(err);
		});
}
